import angular from 'angular';

class UsersEditModalContainer {
  constructor(appErrorHandler, appEvents, users, USERS_EVENTS) {
    'ngInject';

    this.appErrorHandler = appErrorHandler;
    this.appEvents = appEvents;
    this.users = users;
    this.USERS_EVENTS = USERS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.USERS_EVENTS.edit.open,
      (user) => this.openModal(user),
    );

    this.modalTitle = 'Edit information';
    this.user = {};
    this.open = false;
    this.loading = false;
    this.error = '';
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  openModal(user) {
    this.user = angular.copy(user);
    this.open = true;
    const name = this.user.hasName ? this.user.name : this.user.email;
    this.modalTitle = `Edit ${name}`;
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.USERS_EVENTS.edit.close);
  }
  saveModal(userInfo) {
    let result;
    if (this.loading) {
      result = this.$q.reject(new Error('The information are already being saved'));
    } else {
      this.loading = true;
      this.error = '';
      result = this.users.edit(this.user.id, userInfo.name, userInfo.email)
      .then((user) => {
        this.appEvents.emit(this.USERS_EVENTS.edit.save, user);
        this.closeModal();
      })
      .catch((error) => {
        if (error.message) {
          this.error = error.message;
        } else {
          this.appErrorHandler.handle(error, 'There was an error while updating the settings');
        }
      })
      .then(() => {
        this.loading = false;
      });
    }

    return result;
  }
}

export default {
  controller: UsersEditModalContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
    >
      <users-edit-form
        loading="$ctrl.loading"
        error="$ctrl.error"
        user-name="$ctrl.user.name"
        user-email="$ctrl.user.email"
        on-save="$ctrl.saveModal(userInfo)"
        on-cancel="$ctrl.closeModal()"
      ></users-edit-form>
    </modal-wrapper>
  `,
};
